import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class CotacaoService {
  private urlCotacaoDolarPTAXBacen: string =
    'https://olinda.bcb.gov.br/olinda/servico/PTAX/versao/v1/odata/CotacaoDolarPeriodo(dataInicial=@dataInicial,dataFinalCotacao=@dataFinalCotacao)';
  private urlCotacaoAtualBacen: string =
    'https://olinda.bcb.gov.br/olinda/servico/PTAX/versao/v1/odata/CotacaoMoedaDia(moeda=@moeda,dataCotacao=@dataCotacao)';

  constructor(private http: HttpClient) {}

  consultarDolarPTAX() {
    const dataInicial = moment().subtract(5, 'days').format("'MM-DD-YYYY'");
    const dataFinalCotacao = moment().format("'MM-DD-YYYY'");

    const params = new HttpParams()
      .set('@dataInicial', dataInicial)
      .set('@dataFinalCotacao', dataFinalCotacao)
      .set('$top', '10')
      .set('$format', 'json')
      .set('$select', 'cotacaoCompra,cotacaoVenda,dataHoraCotacao');

    return this.http.get<any>(this.urlCotacaoDolarPTAXBacen, { params });
  }

  consultarDolarAtual() {
    const dataCotacao = moment().format("'MM-DD-YYYY'");

    const params = new HttpParams()
      .set('@moeda', "'USD'")
      .set('@dataCotacao', dataCotacao)
      .set('$top', '10')
      .set('$format', 'json')
      .set('$select', 'cotacaoCompra,cotacaoVenda,dataHoraCotacao,tipoBoletim');

    return this.http.get<any>(this.urlCotacaoAtualBacen, { params });
  }
}
